import { ReactElement } from 'react';
import { useIsMobile } from '@synergy/components-next';

import { ShoppingCartSupplier } from '../../../models/shopping-cart';
import { SupplierTableDesktop } from './desktop/supplier-table-desktop';
import { SupplierTableMobile } from './mobile/supplier-table-mobile';

export interface SupplierTableProps {
    supplier: ShoppingCartSupplier;
}

export const SupplierTable = (props: SupplierTableProps): ReactElement => {
    const isMobile = useIsMobile();
    const { supplier } = props;

    return isMobile ? <SupplierTableMobile supplier={supplier} /> : <SupplierTableDesktop supplier={supplier} />;
};
